export const NOTIFICATIONS_CHANGED_EVENT = 'apt-notifications-changed';

export function emitNotificationsChanged(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
}
